import { service } from '@ember/service';

import type { BlockThemeConfig, Service } from 'webapp-types';
import ThemeConfig from 'webapp/const/theme-config';

import type { Args } from 'webapp/components/common/simple-line-chart';
import CommonSimpleLineChartComponent from 'webapp/components/common/simple-line-chart';

export default class ForecastsMyChartComponent extends CommonSimpleLineChartComponent<Args> {
	@service('model-manager/boards') declare mmBoardsService: Service.ModelManager.Boards;
	@service('constants') declare constantsService: Service.Constants;
	@service('navigation') declare navigationService: Service.Navigation;

	get themeData() {
		const color = this.navigationService.theme.isDark
			? this.constantsService.defaultBoardColor
			: '#ffffff';

		const colorConfigBase = this.mmBoardsService.getColorConfig(color);

		const themeConfig = ThemeConfig[0]!;

		const colorConfig: BlockThemeConfig.BlockParsed = Object.assign({}, colorConfigBase, {
			visualizationConfig: this.args.visualization.getBlockThemeConfigContent(
				themeConfig.visualizations,
			),
			colors: themeConfig.colors,
		});

		return colorConfig;
	}
}
